import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { makeStyles } from '@material-ui/core/styles';
import React, { useEffect, useState } from 'react';

import { Typography } from '@material-ui/core';

import MyTextField from '../utils/MyTextField';
import UnoButton from '../utils/UnoButton';

import { getShortMonthName } from '../utils/utils';

import { unoTheme } from '../../assets/styles/unoTheme';

const COMMENT_MAX_LENGTH = 2048;

const useStyles = makeStyles((theme) => ({
    contentModal: {
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: 'white',
        paddingBottom: theme.spacing(3),
    },

    actionsFlex: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
    },

    dialogTitle: {
        '& h2': {
            display: 'flex',
            alignItems: 'center',
            width: '100%',
        }
    },

    clientLabel: {
        fontSize: '14px',
        color: unoTheme.secondaryColor,
    },

    statusLine: {
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(2),
    },

    statusChip: {
        display: 'flex',
        alignItems: 'center',
    },

    statusDot: {
        width: '8px',
        height: '8px',
        marginRight: '6px',
        borderRadius: '50%',
    },

    statusLabel: {
        fontSize: '12px',
        fontWeight: '600',
        letterSpacing: '1px',
    },

    statusArrow: {
        fontSize: '12px',
        fontWeight: '600',
        color: unoTheme.secondaryColor,
        margin: '0px 10px',
    },
}));

export default function ChangeStatusDairModal(props) {

    const classes = useStyles();

    const { open,
        clientInfo,
        currentStatus,
        statusSelected,
        handleAction } = props;

    const [comment, setComment] = useState("");
    const [submitted, setSubmitted] = useState(false);

    useEffect(() => {

        //Evita que o comentário de uma troca anterior vaze para a próxima
        setComment("");
        setSubmitted(false);

    }, [open])

    const emptyComment = comment.trim() === "";
    const exceededComment = comment.trim().length > COMMENT_MAX_LENGTH;

    function renderStatusChip(status) {
        return (
            <div className={classes.statusChip}>
                <div
                    className={classes.statusDot}
                    style={{ backgroundColor: status.color }}></div>
                <Typography
                    className={classes.statusLabel}
                    style={{ color: status.color }}>
                    {status.short_name + ' - ' + status.name}
                </Typography>
            </div>
        );
    }

    function doConfirm() {

        setSubmitted(true);

        if (emptyComment || exceededComment) return;

        handleAction(comment.trim());
    }

    return (
        <Dialog
            fullWidth={true}
            maxWidth={'sm'}
            open={open}
            onClose={() => handleAction(false)}>
            <DialogTitle
                className={classes.dialogTitle}>
                {"Alterar status DAIR"}
            </DialogTitle>

            <DialogContent
                className={classes.contentModal}>

                {
                    clientInfo && clientInfo.client ?
                        <Typography
                            className={classes.clientLabel}>
                            {clientInfo.client.label_name + ' (' + getShortMonthName(clientInfo.month) + '/' + clientInfo.year + ')'}
                        </Typography>
                        : null
                }

                {
                    statusSelected ?
                        <div className={classes.statusLine}>

                            {
                                currentStatus ?
                                    <>
                                        {renderStatusChip(currentStatus)}
                                        <Typography className={classes.statusArrow}>{'→'}</Typography>
                                    </>
                                    : null
                            }

                            {renderStatusChip(statusSelected)}

                        </div>
                        : null
                }

                <MyTextField
                    value={comment}
                    onChange={(value) => setComment(value)}
                    outerlabel={'Comentário'}
                    multiline={true}
                    rows={5}
                    rowsMax={5}
                    placeholder={"Descreva o motivo da alteração do status"}
                    validator={(emptyComment && submitted) || exceededComment ? true : undefined}
                    helperText={exceededComment ?
                        "O comentário excedeu o limite de caracteres"
                        : "Insira um comentário"}
                    fullWidth />

            </DialogContent>

            <DialogActions className={classes.actionsFlex}>

                <UnoButton onClick={() =>
                    handleAction(false)} color="secondary">
                    {'Cancelar'}
                </UnoButton>

                <UnoButton
                    onClick={doConfirm}
                    disabled={emptyComment || exceededComment}
                    color="primary">
                    {"Confirmar"}
                </UnoButton>

            </DialogActions>

        </Dialog>
    );
}
